import { render, staticRenderFns } from "./mainSearch.vue?vue&type=template&id=52906cf5&scoped=true"
import script from "./mainSearch.vue?vue&type=script&lang=js"
export * from "./mainSearch.vue?vue&type=script&lang=js"
import style0 from "./mainSearch.vue?vue&type=style&index=0&id=52906cf5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52906cf5",
  null
  
)

export default component.exports